import { Fragment } from 'react';

/**
 * A slim trust strip for the Get EA hero.
 *
 * It repeats the three facts a visitor weighs before opening the chat, and keeps
 * them consistent with the rest of the site: the 4.8 average rating shown on the
 * homepage testimonials, the real live-account record, and the zero cost. Kept
 * as plain text hops so it stays readable on a light hero background.
 */
const TRUST_ITEMS = [
  { id: 'rating', icon: 'ri-star-fill', lead: '4.8', text: 'average rating' },
  { id: 'live', icon: 'ri-live-line', lead: 'Real live account', text: 'full record published' },
  { id: 'free', icon: 'ri-price-tag-3-line', lead: '100% free', text: 'no license fee, ever' },
];

export default function HeroTrust() {
  return (
    <div className="mt-7 flex flex-wrap items-center gap-x-7 gap-y-3 border-t border-background-200 pt-5">
      {TRUST_ITEMS.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 ? (
            <span className="hidden sm:block w-px h-4 bg-background-300" aria-hidden="true"></span>
          ) : null}
          <span className="inline-flex items-center gap-2">
            <i className={`${item.icon} text-base text-accent-500`} aria-hidden="true"></i>
            <span className="font-num text-sm font-bold text-foreground-950">{item.lead}</span>
            <span className="text-xs text-foreground-500">{item.text}</span>
          </span>
        </Fragment>
      ))}
    </div>
  );
}